import { atom } from 'recoil';

export const toggleSspModels = atom({
    key: 'oracle-rds-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDatabaseNameModalOpen: false,
    },
});

export const isEnvDetailsLoading = atom({
    key: 'oracle-rds-isEnvDetailsLoading',
    default: false,
});

export const orderId = atom({
    key: 'oracle-rds-orderId',
    default: '',
});

export const isExpectedDbSizeValid = atom({
    key: 'oracle-rds-isExpectedDbSizeValid',
    default: false,
});
export const isExpectedDbSizeValidApiLoading = atom({
    key: 'oracle-rds-isExpectedDbSizeValidLoading',
    default: false,
});

export const isDBNameValid = atom({
    key: 'oracle-rds-isDBNameValid',
    default: false,
});

export const sspSubmitOrder = atom({
    key: 'oracle-rds-sspOrder',
    default: {
        // Application Section
        applicationName: null,
        appShortName: null,
        appProfile: null,
        drPriority: null,
        entityDetails: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        environment: null,
        landingZoneDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,

        // Resource Section
        awsAccount: null,
        vpcId: null,
        vpcName: null,
        // subnetId: null,

        // Application Component Security Group Section
        componentName: null,
        componentNameDetails: null,

        // Rds Instance Section
        dbInstanceType: null,
        databaseName: '',
        isManualDBName: false,
        engineVersion: null,
        engine: null,
        majorEngineVersion: null,
        selectedEngineOption: null,
        expDBSize: null,
        isMultiAzEnabled: 'no',
        instanceName: null,
        serverCollation: null,
        timeZone: null,
        storageType: null,
        storageTypeDetails: null,
        isCDBRequired: 'no',
        isMultiTenantRequired: 'no',
        dbNames: [],
        dbCharacterSet: null,

        // Access Management Section
        domain: null,
        adGroup: null,
        adous: null,
        adousDetails: null,
        sqlDbAuthentication: null,
        isSqlAccExist: null,
        sqlAccOwner: null,
        sqlAccOwnerDetails: null,
        sqlServiceAccountName: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'oracle-rds-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'oracle-rds-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'oracle-rds-isValidProvisioningForm',
    default: false,
});

export const isAppNameValid = atom({
    key: 'oracle-rds-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'oracle-rds-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'oracle-rds-isAppShortNameExist',
    default: false,
});
export const showisExistADGrp = atom({
    key: 'oracle-rds-showisExistADGrp',
    default: false,
});

export const isSQLServiceAccountNameValid = atom({
    key: 'oracle-rds-isSQLServiceAccountNameValid',
    default: false,
});
